import basicSalary from '@/api/hr/pay-basic-salary'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  employees: [],
  history: false
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_EMPLOYEE(state, employees) {
    state.employees = employees
  },

  SET_HISTORY_VALUE(state, value) {
    state.history = value
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        history: context.state.history | 0
      },
      attributes
    )
    return basicSalary.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return basicSalary.store(data)
  },

  update(context, { id, data }) {
    return basicSalary.update(id, data)
  },

  destroy(context, id) {
    return basicSalary.destroy(id).then(response => {
      return Promise.resolve(response)
    })
  },
  async dataBeforeCreate(context) {
    if (!context.state.employees.length > 0) {
      let response = await basicSalary.employee()
      context.commit('SET_EMPLOYEE', response.data)
    }
  }
}
